// A labelled usage meter (used of total), coloured orange and red only when it runs high
// (design/isomorphic/src/core/charts.tsx).
import { formatNumber, useLocale } from "../i18n";
import { cn } from "./cn";

export function Meter({
  label,
  used,
  total,
  unit,
  detail,
}: {
  label: string;
  used: number;
  total: number;
  unit: string;
  detail?: string;
}) {
  useLocale();
  const pct = total > 0 ? Math.round((used / total) * 100) : 0;
  const bar = pct >= 85 ? "bg-red" : pct >= 70 ? "bg-orange" : "bg-primary";
  return (
    <div role="meter" aria-label={label} aria-valuemin={0} aria-valuemax={total} aria-valuenow={used}>
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-[13px] font-medium text-gray-700">{label}</span>
        <span className="tabular text-[13px] text-gray-500">
          <span className="font-semibold text-gray-900">{formatNumber(used)}</span> / {formatNumber(total)} {unit}
        </span>
      </div>
      <div className="mt-2 h-2 overflow-hidden rounded-full bg-gray-100">
        <div className={cn("h-full rounded-full", bar)} style={{ width: `${Math.min(100, Math.max(pct, 2))}%` }} />
      </div>
      {detail ? <div className="mt-1.5 text-xs text-gray-500">{detail}</div> : null}
    </div>
  );
}
